import Vue from 'vue'
import AjaxCart from '../helpers/AjaxCart'
import Helpers from '../helpers/Helpers'
import scrollToElement from 'scroll-to-element'

class Bundle {
    constructor (theme) {
        this._theme = theme
        this._data = JSON.parse(document.querySelector('[data-bundle-info]').textContent)
        this._vue = null
    }
    onInit () {
        this._vue = new Vue({
            el: '.bundle__content',
            data: {
                categories: this._data.categories,
                defaultImage: this._data.defaultImage,
                dummy: this._data.dummyProd,
                payload: [],
                active: false,
                adding: false,
                progress: '0%',
                showSizeGuide: false,
                mobile: window.innerWidth < 768,
                soldOut: this._data.soldOut
            },
            mounted: function () {
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                }
            },
            methods: {
                showOptions: function (parent) {
                    const elem = document.querySelector(`#${parent}`)
                    elem.querySelector('.category__product-options').classList.add('active')
                },
                hideOptions: function (parent) {
                    const elem = document.querySelector(`#${parent}`)
                    elem.querySelector('.category__product-options').classList.remove('active')
                },
                toggleAccordion: async function (e) {
                    const categoryElems = document.querySelectorAll('.category__products')
                    const elem = document.querySelector(`#${e}`)
                    if (elem.hasAttribute('style')) {
                        elem.classList.toggle('closed')
                    } else {
                        for (var c = 0; c < categoryElems.length; c++) {
                            categoryElems[c].style.maxHeight = categoryElems[c].scrollHeight + 'px'
                            if (c === categoryElems.length - 1) {
                                elem.classList.toggle('closed')
                            }
                        }
                    }
                    if (elem.classList.contains('closed')) {
                        const height = (document.querySelector('header').offsetHeight - 45) * -1
                        scrollToElement(elem, {
                            offset: height,
                            duration: 500
                        })
                    }
                },
                setVariantPicked: function (product) {
                    product.variantPicked = true
                },
                addProduct: async function (product, id, category) {
                    product.selected = true
                    product.variants.forEach(variant => {
                        if (variant.id === id) {
                            variant.selected = true
                        } else {
                            variant.selected = false
                        }
                    })
                    category.selected = true
                    this.active = true
                    this.closeOverlay(product.key)
                    this.makePayload()
                },
                findProduct: async function (product, key, category) {
                    const value = document.querySelector(`[name="${key}"]:checked`).value
                    for (var i = 0; i < product.variants.length; i++) {
                        if (product.variants[i].options.includes(value)) {
                            await this.addProduct(product, product.variants[i].id, category)
                            break
                        }
                    }
                },
                variantAvailable: function (product, value) {
                    for (var i = 0; i < product.variants.length; i++) {
                        if (product.variants[i].options.includes(value)) {
                            return product.variants[i].available
                        }
                    }
                },
                itemSizes: function (sizes) {
                    let html = ''
                    const sizesArray = sizes.split('**')
                    sizesArray.forEach(size => {
                        let location = size.split('-')[0].trim().toLowerCase()
                        let sizeShow = size.replace('-', ' ').trim()
                        html += `<span class="${location}">${sizeShow}</span>`
                    })
                    return html
                },
                makePayload: function () {
                    let array = []
                    for (var c = 0; c < this.categories.length; c++) {
                        const cat = this.categories[c]
                        if (cat.selected) {
                            for (var p = 0; p < cat.products.length; p++) {
                                const product = cat.products[p]
                                if (product.selected) {
                                    for (var v = 0; v < product.variants.length; v++) {
                                        const variant = product.variants[v]
                                        if (variant.selected) {
                                            const quantity = 1
                                            let payload = {quantity, id: variant.id}
                                            array.push(payload)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.payload = array
                    if (this.payload.length === 0) {
                        this.active = false
                    }
                    this.progress = (this.payload.length / this.categories.length) * 100 + '%'
                },
                addBundle: async function () {
                    this.adding = true
                    for (var i = 0; i < this.payload.length; i++) {
                        await AjaxCart.addItem(this.payload[i])
                    }
                    window.location.href = '/cart'
                },
                removeItem: function (category, product, variant) {
                    category.selected = false
                    product.selected = false
                    if (variant) {
                        variant.selected = false
                    } else {
                        product.variants.forEach(option => {
                            option.selected = false
                        })
                    }
                    this.makePayload()
                },
                showModal: function () {
                    this.showSizeGuide = true
                },
                closeModal: function () {
                    this.showSizeGuide = false
                },
                mobileOverlay: function (target) {
                    const overlay = document.querySelector(`#${target} .bundle__product-overlay`)
                    if (overlay) {
                        overlay.classList.remove('visually-hidden')
                        document.body.classList.add('no-scroll')
                    }
                },
                closeOverlay: function (target) {
                    const overlay = document.querySelector(`#${target} .bundle__product-overlay`)
                    if (overlay) {
                        overlay.classList.add('visually-hidden')
                        document.body.classList.remove('no-scroll')
                    }
                }
            }
        })
        window.vueJob = this.vue
    }
}
export default Bundle



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Bundle.js